var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrackingMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3596 33.0066L47.0063 39.0399L40.3929 42.4532L38.2063 39.9066L32.7863 39.0732L31.3529 46.1466L25.9463 51.3199L31.4196 55.2133L34.1863 53.0733L37.5663 60.4599L51.0596 60.0066L56.6396 64.9999L60.7996 61.2533L59.5663 56.4666L64.2196 54.0133L62.573 42.5599L64.9996 38.8466L60.1729 30.8799L51.3596 33.0066Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65336 3.67334L13.3733 6.70001L19.58 2.24667L28.24 1L30.5933 3.58L28.3934 5.88001L30.1333 10.54L23.7334 12.9667L23.8667 19.62L17.74 22.3334L16.34 29.5667L9.60002 30.1801L1 19.5934L3.06669 12.74L1 8.92668L5.65336 3.67334Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0462 13.3533C11.0462 13.3533 10.9795 13.6533 10.8662 14.1866",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5132 18.1C11.7761 18.1 12.7999 17.0762 12.7999 15.8133C12.7999 14.5504 11.7761 13.5266 10.5132 13.5266C9.25033 13.5266 8.22656 14.5504 8.22656 15.8133C8.22656 17.0762 9.25033 18.1 10.5132 18.1Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5806 50.9869C54.8435 50.9869 55.8673 49.9631 55.8673 48.7002C55.8673 47.4374 54.8435 46.4136 53.5806 46.4136C52.3177 46.4136 51.2939 47.4374 51.2939 48.7002C51.2939 49.9631 52.3177 50.9869 53.5806 50.9869Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9928 48.0401C18.2556 48.0401 19.2794 47.0164 19.2794 45.7535C19.2794 44.4906 18.2556 43.4668 16.9928 43.4668C15.7299 43.4668 14.7061 44.4906 14.7061 45.7535C14.7061 47.0164 15.7299 48.0401 16.9928 48.0401Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0739 26.5203L49.7939 26.5203V11.8002L35.0739 11.8002V26.5203Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5673 16.8066H44.2939V11.8066H40.5673V16.8066Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1342 23.0332H42.8809",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90723 19.9599C9.98056 19.3933 10.0605 18.8466 10.1339 18.3333",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54688 23.2332C9.59354 22.6732 9.65354 22.1265 9.70687 21.5999",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33984 26.5135C9.35984 25.9602 9.39318 25.4135 9.42651 24.8735",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30695 29.8C9.29361 29.2533 9.29361 28.7 9.30028 28.1533",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49972 33.0868C9.44638 32.5468 9.39971 32.0001 9.37305 31.4468",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99939 36.3334C9.88606 35.8067 9.79272 35.26 9.70605 34.7134",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9194 39.4868C10.7261 38.9868 10.5527 38.4668 10.3994 37.9268",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4461 42.3935C12.1328 41.9535 11.8461 41.4868 11.5928 40.9868",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7735 44.6936C14.3202 44.387 13.8935 44.0336 13.5068 43.647",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.12 46C20.5867 46.12 20.0333 46.1733 19.46 46.1667",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1267 44.5864C23.6667 44.9264 23.1934 45.2131 22.6934 45.4531",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5328 42.2734C26.1661 42.7134 25.7861 43.1268 25.3994 43.5068",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4996 39.5669C28.1929 40.0402 27.8796 40.5069 27.5596 40.9469",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2334 36.6997C29.9534 37.1864 29.6734 37.6664 29.3867 38.1397",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8862 33.7935C31.6129 34.2801 31.3396 34.7668 31.0596 35.2535",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5864 30.9067C33.2931 31.3734 33.0064 31.8534 32.7197 32.3401",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4867 28.1533C35.1534 28.58 34.82 29.0333 34.5 29.5067",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4264 29.8069C50.2064 29.2736 49.9731 28.7603 49.7197 28.2603",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M51.533 33.0131C51.373 32.4664 51.2064 31.9264 51.0264 31.3931",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3333 36.3133C52.22 35.76 52.0933 35.2067 51.96 34.6533",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.92 39.6531C52.84 39.0998 52.7533 38.5398 52.6533 37.9731",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3265 43.0265C53.2732 42.4798 53.2132 41.9132 53.1465 41.3398",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5801 46.4136C53.5535 45.8802 53.5135 45.3135 53.4668 44.7202",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingMobile);
export default __webpack_public_path__ + "static/media/tracking_mobile.401094ffdb3f278926ddbb19ae09baff.svg";
export { ForwardRef as ReactComponent };